import { isLinkedCloudInstance } from '../utilities/instanceHelper';
import { useTaniumInstances } from './useTaniumInstances';

export const useHasLinkedCloudInstances = (): boolean => {
  const { linkedTaniumInstances = [] } = useTaniumInstances();
  return linkedTaniumInstances.some(isLinkedCloudInstance);
};
